export default "/fonts/vendor/summernote/dist/summernote.woff2?7c9436ed8d2deac04e375be2d373e647";